import pluralize from "pluralize";

export const singular = (string) => pluralize(string, 1);
export const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
};
